import React from "react";
import "./Terms.css";

export default function Terms() {
  return (
    <div className="Terms">
      <h1>使用條款</h1>
      <p>歡迎使用 Stake！</p>
      {/* <p>
        Stake是由Tooltips Tech
        Limited（下稱我們）所經營之APP各項服務與資訊。本使用條款規範您的 Stake
        使用行為，並提供 Stake 服務的相關資訊，詳情如下所述。若建立 Stake
        帳號或使用 Stake，即表示您同意本條款。
      </p> */}
      <p>
        Stake是由應用開發者（下稱我們）所經營之APP各項服務與資訊。本使用條款規範您的
        Stake 使用行為，並提供 Stake 服務的相關資訊，詳情如下所述。若建立 Stake
        帳號或使用 Stake，即表示您同意本條款。
      </p>
      <h2>Stake 服務</h2>
      <p>
        我們同意提供您 Stake 服務，包括所有 Stake
        產品、功能、應用程式、服務、技術和軟件，以達成 Stake
        的使命，拉近您與社區之間的距離。Stake
        服務是由下列面向組成（下稱「本服務」）：
      </p>
      <p>
        ·
        讓用戶依個人喜好建立內容、與他人聯繫交流、發掘新事物和分享資訊。每個人都有所不同，我們希望透過您所重視並分享的經驗，強化您與社區之間的關係。因此，我們打造的系統旨在瞭解您和其他用戶關心的人事物，並運用該等資訊來協助您建立、找到、參與和分享對您而言重要的體驗，包括挑選出您可能感興趣的內容、功能、優惠和帳號，並根據您和其他用戶在
        Stake 與其他網路空間的行為，為您提供各種體驗 Stake 服務的方式。
      </p>
      <ul>
        <li>
          營造正面、包容且安全的使用環境。我們開發並運用各種工具，為社群成員提供所需資源，包括在我們認為成員可能需要協助時，向其提供協助，使其獲得兼容並蓄的正面體驗。我們也建立相關團隊和系統，專門處理濫用、違反使用條款及政策等情事，以及有害及詐欺的行為。我們會使用所有手邊既有的資料（包含您的資料），盡力維護平台安全。
        </li>
        <li>
          開發並使用新技術，使我們為不斷茁壯的社群持續提供服務。為日益壯大的社群整理並分析資訊，是本服務的核心所在。本服務的一大重點，在於開發並使用尖端技術，使我們為遍及全球的廣大社群，大規模個人化、保護及改善我們的服務。人工智慧和機器學習等技術，使我們能將複雜的程序應用在各項服務中，自動化技術則幫助我們確保本服務之功能及完整。
        </li>
        <li>
          以您喜歡的方式，建立您與品牌、產品和服務之間的聯繫。我們會使用
          Stake及第三方合作夥伴所提供的資料，向您顯示我們認為對您有意義的廣告、優惠和其他贊助內容，並盡力使這些內容和您在
          Stake 所有其他使用體驗一樣與您切身相關。
        </li>
        <li>
          研究與創新。我們會運用既有資料來分析本服務，並與他人合作研究，一同提升本服務之品質，為我們的社群創造福祉。
        </li>
      </ul>
      <h2>個人資料（私隱）政策</h2>
      <p>
        為向您提供Stake服務，我們必須蒐集您的資料。本個人資料（私隱）政策說明我們如何在蒐集、使用和分享資料，並說明您可以透過哪些方式控管資料，例如調整
        Stake 隱私設定和帳號安全設定。 您必須同意資料政策，才能使用 Stake。
      </p>
      <h3>個人資料（私隱）保護政策的適用範圍</h3>
      <ul>
        <li>
          請您在於使用Stake服務前，確認您已審閱並同意本個人資料（私隱）政策所列全部條款，若您不同意全部或部份者，則請勿使用Stake服務。
        </li>
        <li>
          個人資料（私隱）保護政策內容，包括我們如何處理您在使用Stake服務時蒐集到的個人識別資料。
        </li>
        <li>
          個人資料（私隱）保護政策不適用於Stake以外的相關連結網站，亦不適用於非我們所委託或參與管理之人員。
        </li>
      </ul>
      <h3>個人資料的蒐集及使用</h3>
      <ul>
        <li>
          於一般瀏覽時，伺服器會自行記錄相關行徑，包括您使用連線設備的IP位址、使用時間、使用的瀏覽器、瀏覽及點選資料記錄等，做為我們增進服務的參考依據，此記錄為內部應用，絕不對外公布。
        </li>
        <li>
          在使用我們的服務時，我們可能會要求您向我們提供可用於聯繫或識別您的某些個人資料，包括：
        </li>
      </ul>
      <p>o 辨識個人者： 如姓名、地址、電話、電子郵件等資訊。</p>
      <p>o 辨識財務者： 如信用卡或金融機構帳戶資訊。</p>
      <p>o 政府資料中之辨識者： 身分證統一編號、統一證號等。</p>
      <p>o 個人描述：例如：性別、出生年月日等。</p>
      <ul>
        <li>Stake將蒐集的數據用於各種目的：</li>
      </ul>
      <p>o 提供和維護系統所提供讀服務</p>
      <p>o 提供用戶支持</p>
      <p>o 提供分析或有價值訊息，以便我們改進服務</p>
      <p>o 監控服務的使用情況</p>
      <p>o 檢測，預防和解決技術問題</p>
      <ul>
        <li>Stake針對蒐集數據的利用期間、地區、對象及方式：</li>
      </ul>
      <p>o 期間：當事人要求停止使用或本服務停止提供服務之日為止。</p>
      <p>o 地區：個人資料將用於中華人民共和國香港特別行政區。</p>
      <p>
        o
        利用對象及方式：所蒐集到的資料將利用於各項業務之執行，利用方式為因業務執行所必須進行之各項分析、聯繫及通知。
      </p>
      <h3>資料的保護與安全</h3>
      <ul>
        <li>
          Stake主機均設有防火牆、防毒系統等相關資訊安全設備及必要的安全防護措施，Stake及您的個人資料均受到嚴格的保護。只有經過授權的人員才能接觸您的個人資料，相關處理人員均有簽署保密合約，如有違反保密義務者，將會受到相關的法律處分。
        </li>
        <li>
          如因業務需要有必要委託Stake相關單位提供服務時，我們會要求其遵守保密義務，並採取相當之檢查程序以確定其將確實遵守。
        </li>
        <li>
          請您妥善保管您的密碼與個人資料，並提醒您使用完畢Stake相關服務後，務必關閉Stake，以免您的資料遭人盜用。
        </li>
        <li>
          您同意在使用Stake服務時，所留存的資料與事實相符。另若以後您發現您的個人資料遭他人非法使用或有任何異常時，應即時通知我們。
        </li>
        <li>
          您同意於使用Stake服務時，所提供及使用之資料皆為合法，並無侵害第三人權利、違反第三方協議或涉及任何違法行為。如因使用Stake服務而致第三人損害，除因我們故意或重大過失所致外，我們並不負擔相關賠償責任。
        </li>
      </ul>
      <h3>對外的相關連結</h3>
      <p>
        Stake上有可能包含其他合作網站或網頁連結，該網站或網頁也有可能會蒐集您的個人資料，不論其內容或個人資料（私隱）政策為何，皆與Stake
        無關，您應自行參考該連結網站中的個人資料（私隱）保護政策，我們不負任何連帶責任。
      </p>
      <h3>與第三人共用個人資料之政策</h3>
      <ul>
        <li>
          Stake絕不會提供、交換、出租或出售任何您的個人資料給其他個人、團體、私人企業或公務機關，但有法律依據或合約義務者，不在此限。
        </li>
        <li>前項但書之情形包括但不限於：</li>
      </ul>
      <p>o 經由您同意。</p>
      <p>o 法律明文規定。</p>
      <p>o 為維護國家安全或增進公共利益。</p>
      <p>o 為免除您生命、身體、自由或財產上之危險。</p>
      <p>o 當資料經過提供者處理或蒐集者依其揭露方式無從識別特定之當事人。</p>
      <p>
        o
        當您在APP的行為，違反服務條款或可能損害或妨礙APP與其他使用者權益或導致任何人遭受損害時，經APP管理單位研析揭露您的個人資料是為了辨識、聯絡或採取法律行動所必要者。
      </p>
      <p>o 有利於您的權益。</p>
      <ul>
        <li>
          Stake委託廠商協助蒐集、處理或利用您的個人資料時，將對委外廠商或個人善盡監督管理之責。
        </li>
      </ul>
      <h3>Cookie之使用</h3>
      <p>
        ·
        為了提供您最佳的服務，本網站會在您的電腦中放置並取用我們的Cookie，若您不願接受Cookie的寫入，您可在您使用的瀏覽器功能項中設定個人資料（私隱）等級為高，即可拒絕Cookie的寫入，但可能會導致網站某些功能無法正常執行
        。以下是可能使用的Cookie範例:
      </p>
      <p>o 用來維護應用程式的狀態</p>
      <p>o 用來記錄您的喜好與設定</p>
      <p>o 用來控制安全和檢查</p>
      <h3>未成年人保護</h3>
      <p>
        未成年人於註冊或使用本服務而同意本公司蒐集、利用其個人資訊時，應按其年齡由其法定代理人代為或在法定代理人之同意下為之。
      </p>
      <h3>個人資料（私隱）政策的修訂</h3>
      <p>
        我們將因應需求擁有隨時修改本個人資料（私隱）保護政策的權利，當我們做出修改時，會於Stake公告，且自公告日起生效，不再另行通知。
      </p>
      <h2></h2>
      <h2>您的承諾</h2>
      <p>若要使用我們承諾提供的服務，您也必須承諾遵守以下事項。</p>
      <h3>誰可以使用 Stake</h3>
      <p>
        我們希望盡力營造開放包容的服務環境，同時兼顧安全可靠與法規遵循。因此，加入
        Stake 社群之前，請您務必確認自身符合以下條件。
      </p>
      <ul>
        <li>
          您必須年滿 13 歲，或達到您所在國家／地區法律規定可使用 Stake
          的最低年齡。
        </li>
        <li>
          依適用法律規定，您必須有權使用我們的任何服務；如果您名列適用的拒絕往來對象名單，將無法使用我們的付款服務。
        </li>
        <li>您先前並未因違反法律或我們的任何政策，而遭我們停用帳號。</li>
        <li>您不得為經判決有罪之性罪犯。</li>
      </ul>
      <h3>您遭禁止使用 Stake 之情況</h3>
      <p>我們必須同心協力，才能為廣大社群用戶共創安全開放的服務。</p>
      <ul>
        <li>
          請勿冒充他人或提供錯誤資訊。
          <br />
          您不必在 Stake
          揭露自己的身分，但必須向我們提供正確且即時的資訊（包括註冊資訊）。此外，您亦不得冒充他人，或是未經他人明確同意即為其建立帳號。
        </li>
        <li>
          不得進行任何違法、誤導或詐欺的行為，亦禁止為達成非法或未經授權之目的而從事的一切行為。
        </li>
        <li>不得違反（或是協助或勸誘他人違反）本條款或我們的政策。</li>
        <li>請勿以任何方式干擾或損害本服務之正常運作。</li>
        <li>
          請勿嘗試透過未經授權的方式建立帳號，或是存取或蒐集資訊。
          <br />
          未經我們明確同意，亦不得透過自動化的方式建立帳號或蒐集資訊。
        </li>
        <li>
          請勿嘗試購買、販售或移轉您帳號的任何部分（包括用戶名稱），亦不得徵求、蒐集或使用其他用戶的登入憑證或標章。
        </li>
        <li>
          請勿發佈私密或機密資訊，或進行任何侵犯他人權利（包括智慧財產權）的活動。
        </li>
        <li>
          未經我們事先書面同意，您不得在自己的用戶名稱中使用網域名稱或網址。
        </li>
        <li>
          請勿上載、張貼、發送電子郵件或傳送任何非法、有害、脅迫、濫用、騷擾、侵害、中傷、粗俗、猥褻、誹謗、侵害他人私隱、有害或種族歧視的或道德上令人不快的「內容」。
        </li>
      </ul>
      <h3>您授予我們的權限</h3>
      <p>根據本協議內容，您亦授予我們提供本服務時所需的權限。</p>
      <ul>
        <li>
          我們對您提供的內容並無所有權，但您授予我們使用該內容的權限。您對您相關內容之所有權不受影響。我們對您在本服務或透過本服務發佈的內容並無所有權。
          當您在我們的服務或相關平台上分享、發佈或上傳受智慧財產權保障的內容（例如相片或影片）時，即表示您授予我們非專屬、免權利金、可轉讓、可轉授權的全球授權，可以託管、使用、散佈、修改、執行、複製、公開表演或展示、翻譯您的內容，以及根據您的內容創作衍生作品（須符合您的隱私和應用程式設定）。您可以隨時刪除您的內容或帳號，以結束此授權。不過，若您曾與他人分享您刪除的內容，而您所分享對象並未將其刪除，則該內容仍可能會持續出現。
        </li>
      </ul>
      <p>
        ·
        您的用戶名稱、大頭貼照和社群關係資訊的使用權限，以及您對帳號、廣告和贊助內容所採取之動作資訊的使用權限。您允許我們將您的用戶名稱、大頭貼照以及有關您動作（例如按讚）與社群關係（例如追蹤）的資訊，顯示在於
        Stake
        產品呈現、且您追蹤或點擊的帳號、廣告、優惠和其他贊助內容旁邊或相關位置，且不必提供您任何報酬。舉例來說，若某個品牌付費在
        Stake
        刊登廣告，而您對該品牌撰寫的贊助貼文按讚，我們得顯示您曾對該則貼文按讚。如同您對其他內容採取動作和追蹤其他帳號，若您對贊助內容採取動作和追蹤贊助帳號，只有有權查看或追蹤該內容的用戶可以看到相關資訊。我們也會尊重您的廣告設定。
      </p>
      <ul>
        <li>您同意我們得在您的裝置下載並安裝本服務的更新內容。</li>
      </ul>
      <h3>我們保留的其他權利</h3>
      <ul>
        <li>
          如果您為您的帳號選擇用戶名稱或類似的識別資料，在我們判定為適當或必要的情況下（例如該資料侵犯他人的智慧財產權或冒充其他用戶），我們得變更該項資料。
        </li>
        <li>
          如果您使用的內容屬於我們所擁有之智慧財產權涵蓋的範圍，且該智慧財產權在本服務中提供（例如您建立或分享內容時，加入我們提供的圖像、設計、影片或音效），我們將保留對該內容（不包括您自有內容）的所有權利。
        </li>
        <li>
          您必須事先取得我們的書面同意，才能使用我們的智慧財產和商標（或相似標記）。
        </li>
        <li>
          您必須取得我們的書面同意或在開放原始碼授權許可下，才能修改、創造衍生作品、反編譯或以其他方式嘗試擷取我們的原始程式碼。
        </li>
      </ul>
      <h3>移除內容，並將您的帳號停用或停權</h3>
      <ul>
        <li>
          如果我們認為您在本服務中分享的任何內容或資訊違反了本使用條款，或我們依法可以或必須執行，我們得移除這些內容或資訊。在下列情況下，我們得拒絕或立即停止向您提供全部或部分服務（包括將您的帳號永久停權或暫時停用），以保護我們的社群或服務：您使我們暴露在風險和法律問題當中；您違反本使用條款；您一再侵害他人的智慧財產權；或我們依法可以或必須停止向您提供服務。若我們將您的帳號暫時停用或永久停權，我們會於適當時通知您。
        </li>
        <li>
          我們會將您所刪除內容的備份副本保留一定時間；若有人分享該內容，其他用戶仍然能夠查看。本段與下方「我們的協議與發生爭議時的處理方式」一節，在您的帳號終止或刪除後依然適用。
        </li>
      </ul>
      <h2>我們的協議與發生爭議時的處理方式</h2>
      <h3>我們的協議</h3>
      <ul>
        <li>本協議如有任何條款無法執行，其餘條款仍為有效。</li>
        <li>
          對本協議的任何修訂或放棄必須以書面提出，並經我們簽署。如果我們未執行本協議的任何條款，並不會被視為放棄任何權利。
        </li>
        <li>我們保留所有未明確授予您的權利。</li>
      </ul>
      <h3>本協議授予權利的對象</h3>
      <ul>
        <li>本協議並未將權利授予任何第三方。</li>
        <li>未經我方同意，您不得移轉本協議之權利或義務。</li>
        <li>
          我方的權利和義務得移轉予他人。例如，若我方的所有權變更（例如合併、收購或出售資產），或依法律要求而變更時，權利、義務便可能移轉。
        </li>
      </ul>
      <h3>發生問題時的責任方</h3>
      <ul>
        <li>
          我們的服務是「依現狀」提供，因此我們無法保證服務的運作一定安全、可靠，或絕對不會故障。在法律所允許的範圍內，我們亦明確聲明不負任何明示或默示之擔保責任，其中包括適銷性、特定用途的適用性、所有權及非侵權等默示擔保。
        </li>
        <li>
          我們無法控制其他用戶的言行，因此我們對他們（或您）的動作或行為（無論線上或離線）及分享的內容（包括違法和其他令人反感的內容）概不負任何責任。我們對其他用戶或公司提供的服務和功能概不負責，即使您透過我們的服務使用該等服務及功能亦然。
        </li>
        <li>
          對於本服務中所發生之任何情事，我們的責任僅限於法律所要求的範圍內（亦稱「責任」）。若我們的服務發生問題，我們無法掌握所有可能的影響。您同意我們對於任何損失的利益、收益、資訊或資料，以及因本條款所生或相關的任何衍生、特殊、間接、懲戒性、懲罰性或附帶性損害，概不負責，即便在我們已得知可能發生該等損害的情況下亦然。我們刪除您的內容、資料或帳號時，亦適用本條件。
        </li>
      </ul>
      <p>
        發生爭議時的處理方式
        <br />
        如果您是消費者，您與我們之間因本條款所生或相關的任何索賠、訴訟原因或爭議（下稱「索賠」），皆適用您所居住國家／地區的法律，而且您也可以尋求該國家／地區具有相關管轄權的管轄法院解決索賠事宜。在其他狀況下，您同意只能在中華人民共和國香港特別行政區的法院解決索賠事宜。您也同意基於提出所有這類索賠的目的，服從上述法院的個人管轄權，且本條款與任何索賠一律受中華人民共和國香港特別行政區法律所規範，縱使與法律條款牴觸時亦同。
      </p>
      <p>
        <br />
        主動提供的資料
        <br />
        我們一向樂意聽取意見回饋或其他建議，但我們得任意使用這些內容，且無須向您提供任何報酬，對相關內容亦無保密義務。
      </p>
      <h2>更新本條款</h2>
      <p>
        本服務和政策可能時有變更，因此我們可能須修改本條款，以確實反映服務與政策內容。除法律另有規定者外，我們會於變更本條款內容前事先通知您（例如透過本服務等管道），讓您可在變更內容生效前審閱相關條款。若您在變更生效後，仍繼續使用本服務，即表示您願意受新修訂的條款內容約束。如果您不同意本條款或任何新版條款，可以刪除帳號。
      </p>
      <p>修訂：2020 年 3月 8 日</p>
    </div>
  );
}
